import root from './root';

const {combineReducers} = require('@cloud/redux-immutable');
const {createReducer} = require('@src/components/redux-act');

export default combineReducers({
  root: createReducer(root)
});
